import checklist from '../../img/get-started/checklist.png';
import React, { Component } from 'react';
import hired from '../../img/get-started/hired.png';
import select from '../../img/get-started/select.png';
// import hiring from '../../img/get-started/hiring.png';
// import development from '../../img/get-started/development.png';
import checklistColor from '../../img/get-started/checklist-color.png';
import hiredColor from '../../img/get-started/hired-color.png';
import selectColor from '../../img/get-started/select-color.png';
// import hiringColor from '../../img/get-started/hiring-color.png';
// import developmentColor from '../../img/get-started/development-color.png';

export default [
  {
    id: 'getting-started-1',
    title: 'Complete Security Training',
    desc: `HIPAA requires every member of the organization with access to ePHI to receive security training.
     The good news is that we have made it easy and hopefully more enjoyable than training you may previously have had.`,
    body: <p>Go to the <a href="/app/training/security">Security Training</a> module. You will see 6 videos that are each
     approximately 5 minutes long. These videos will give you a basic overview of the key ways in which organizations can be breached.
      After you have watched them, take the <a href="/app/training/securityawareness">Security Quiz</a> as the required evidence of your training and understanding.
    </p>,
    defaultIcon: checklist,
    colorIcon: checklistColor,
    media: [checklist],
    url: `/app/training/security`,
    download: false,
    show: false
  },
  {
    id: 'getting-started-2',
    title: 'Complete HIPAA Training',
    desc: `Ongoing security training is not only a requirement of HIPAA but is a fundamental best practice in any strong security program. Every month, we will email  a new video that addresses  current security risks.`,
    body: <p>Go to the <a href="/app/training/hipaa">HIPAA Training</a> module. You will see 3 videos that give you an overview of expectations of HIPAA privacy requirements for electronic protected health information (ePHI).
     After you have watched these videos, take the <a href="/app/training/hipaaawarenessquiz">HIPAA Quiz</a> as the required evidence of your training and understanding.</p>,
    defaultIcon: hired,
    colorIcon: hiredColor,
    media: [hired],
    url: `/app/training/security`,
    download: false,
    show: false
  },
  {
    id: 'getting-started-3',
    title: 'Monthly Security Training',
    desc: `Ongoing security training is not only a requirement of HIPAA but is a fundamental best practice in any strong security program. Every month, we will send out a new video based on current security risks.`,
    body: <p>We will send you an email reminder to  watch the monthly security video.  It will be followed by a one-question quiz. You can access this training from the red button entitled “This Month’s Video” on the <a href="/app/training/security">Security Training</a> main page. Your participation will be rewarded with points that will be shared with your administrators.</p>,
    url: `/app/training/security`,
    defaultIcon: select,
    colorIcon: selectColor,
    download: false,
    show: false
    // gif: '	https://s3-us-west-2.amazonaws.com/posture-assets/gifs/select_frameworks.gif',
  },
  //NOTE: DO NOT REMOVE COMMENTED CODE, IT IS COMMENTED OUT FOR BETA HIPAA USERS
  // {
  //   id: 'getting-started-4',
  //   title: 'Assign Controls and Link Evidence',
  //   desc: `Posture makes it easy to assign controls and link evidence using Agile best practices of the 
  //   whole team approach to gain accountability and visibility within your organization. Complete this step 
  //   by assigning your first control to a team member.`,
  //   body: `In this video, we walk through how you can assign controls to a user and even add evidence. Head 
  //   to a framework page to start assigning controls. Get started by heading to the dashboard, enabling a 
  //   framework and start assigning controls for that framework.`,
  //   url: `/app/dashboard`,
  //   defaultIcon: hiring,
  //   colorIcon: hiringColor,
  //   gif: 'https://s3-us-west-2.amazonaws.com/posture-assets/gifs/assign_controls.gif'
  // },
  // {
  //   id: 'getting-started-5',
  //   title: 'Track Progress on Dashboard',
  //   desc: `Head to the dashboard to view your overall compliance, upcoming controls and general overview of controls
  //   and frameworks.`,
  //   body: `Take a look at this video see what data is available on the dashboard.`,
  //   defaultIcon: development,
  //   colorIcon: developmentColor,
  //   url: `/app/dashboard`,
  //   gif: 'https://s3-us-west-2.amazonaws.com/posture-assets/gifs/track_progress.gif'
  // }
]


// WEBPACK FOOTER //
// ./src/components/get-started/StepData-RegularUsers.js